export const en: Record<string, string> = {
  // Nav
  'nav.translator': 'Translator',
  'nav.homepage': 'Homepage',
  'nav.editProfile': 'Edit Profile',
  'nav.logout': 'Logout',
  'nav.signIn': 'Sign In',

  // Hero
  'hero.badge': 'Translator AI App',
  'hero.title': 'Break Down Language Barriers',
  'hero.subtitle': 'Break down language barriers in seconds. Translate text, images, and voice across 100+ languages instantly with our professional AI translator.',
  'hero.getStarted': 'Get Started',
  'hero.ctaButton': 'Start Free Translation Now',
  'hero.noCreditCard': 'No credit card required',
  'hero.urgency': '🔥 Limited to 10 free translations',
  'hero.urgencyDynamic': 'You have {count} free translations left',
  'hero.trustSecure': '🔒 Secure & Private',
  'hero.valueBullet1': 'Translate text, images and voice instantly',
  'hero.valueBullet2': 'Supports 100+ languages worldwide',
  'hero.valueBullet3': 'Fast, accurate, and secure',

  // Translator page
  'translator.textTranslation': 'Text Translation',
  'translator.imageTranslation': 'Image Translation',
  'translator.voiceTranslation': 'Voice Translation',
  'output.label': 'Output Mode',
  'output.text': 'Text',
  'output.voice': 'Voice',
  'output.both': 'Both',

  // Text Translation
  'text.sourceLanguage': 'Source Language',
  'text.targetLanguage': 'Target Language',
  'text.autoDetect': 'Auto-detect',
  'text.text': 'Text',
  'text.words': 'words',
  'text.placeholder': 'Enter text here to translate...',
  'text.translation': 'Translation',
  'text.translationPlaceholder': 'Translation will appear here...',
  'text.translate': 'Translate',
  'text.translating': 'Translating...',
  'text.enterText': 'Please enter your text to get started!',
  'text.translationComplete': 'Translation complete!',
  'text.copy': 'Copy',
  'text.speak': 'Speak',
  'text.speaking': 'Speaking...',
  'text.download': 'Download',
  'text.copiedToClipboard': 'Copied to clipboard!',
  'text.downloadedSuccessfully': 'Downloaded successfully!',
  'text.ttsNotSupported': 'Text-to-speech not supported in your browser',
  'text.trialEnded': 'Your trial has ended. Subscribe to continue using the translator.',
  'text.somethingWentWrong': 'Something went wrong. Please try again in a moment.',
  'text.swap': 'Swap languages',
  'text.paste': 'Paste',
  'text.tone': 'Tone',
  'text.toneStandard': 'Standard',
  'text.toneFormal': 'Formal',
  'text.toneCasual': 'Casual',
  'text.toneBusiness': 'Business',
  'text.toneFriendly': 'Friendly',
  'text.detectedLanguage': 'Detected: {lang}',
  'text.characters': 'characters',
  'text.pastedFromClipboard': 'Pasted from clipboard!',
  'text.autoTranslating': 'Auto-translating...',
  'text.newTranslation': 'New Translation',
  'text.newTranslationTooltip': 'Start a new translation instantly',
  'text.resetConfirmTitle': 'Start over?',
  'text.resetConfirmDescription': 'This will clear your current text and results.',
  'text.keepEditing': 'Keep editing',
  'text.clearAll': 'Clear all',

  // Image Translation
  'image.uploadImage': 'Upload Image',
  'image.clickToUpload': 'Click to upload or drag & drop image',
  'image.fileTypes': 'PNG, JPG, JPEG (max 5MB)',
  'image.extractText': 'Extract Text',
  'image.extractingText': 'Extracting text...',
  'image.extractedText': 'Extracted Text (Editable)',
  'image.translateExtracted': 'Translate Extracted Text',
  'image.textExtracted': 'Text extracted successfully!',
  'image.noTextFound': 'No readable text found in this image. Please try a clearer image.',
  'image.uploadFirst': 'Please upload an image first!',
  'image.noTextToTranslate': 'No text to translate. Please extract text from an image first!',
  'image.pngJpgOnly': 'Please upload PNG, JPG, or JPEG files only.',
  'image.maxSize': 'Image must be under 5MB. Please compress or choose a smaller image.',
  'image.extractionFailed': 'Failed to extract text. Please try again.',

  // Voice Translation
  'voice.inputTitle': 'Voice Input',
  'voice.outputTitle': 'Translation Output',
  'voice.recording': 'Recording in progress…',
  'voice.transcribing': 'Transcribing audio…',
  'voice.generatingAudio': 'Generating premium MP3…',
  'voice.ready': 'Ready for translation',
  'voice.uploadAudio': 'Upload Audio File',
  'voice.transcript': 'Transcript',
  'voice.transcriptPlaceholder': 'Your voice transcript will appear here. You can edit it before translating.',
  'voice.translateVoice': 'Translate Voice',
  'voice.transcriptionReady': 'Transcript ready to review!',
  'voice.transcriptionFailed': 'Voice transcription failed. Please try again with a clearer recording.',
  'voice.transcriptionHelp': 'We couldn’t detect speech. Try speaking clearly or upload an audio file instead.',
  'voice.enterTranscript': 'Please record or upload audio first.',
  'voice.micDenied': 'Microphone permission is required to record audio.',
  'voice.recordingUnsupported': 'This browser does not support in-app recording. Please upload an audio file instead.',
  'voice.recordingEmpty': 'No audio was captured. Please try recording again.',
  'voice.recordingTooShort': 'Recording too short. Please speak for at least 1–2 seconds.',
  'voice.recordedDuration': 'Recorded: {seconds} seconds',
  'voice.fileTooLarge': 'Audio must be under 20MB.',
  'voice.uploadingAudio': 'Uploading audio…',
  'voice.processingAudio': 'Processing audio…',
  'voice.unsupportedFormat': 'Unsupported audio format. Please try again or upload WAV, MP3, or M4A.',
  'voice.noSpeechDetected': 'We couldn’t detect speech. Try speaking clearly or check your microphone.',
  'voice.serviceUnavailable': 'The voice transcription service is temporarily unavailable. Please try again shortly.',
  'voice.invalidApiConfiguration': 'Voice transcription is unavailable due to a service configuration issue. Please contact support.',
  'voice.missingOpenAIKey': 'Missing OpenAI API key for transcription. Please contact support.',
  'voice.quotaExceeded': 'Voice transcription quota has been exceeded. Please try again later.',
  'voice.serviceFallback': 'Voice service is temporarily unavailable. Please try again shortly or use text input for now.',
  'voice.audioOnlyReady': 'Audio playback controls are ready below.',
  'voice.original': 'Original transcript',
  'voice.translated': 'Translated result',
  'voice.awaitingInput': 'Waiting for voice input…',
  'voice.audioOutput': 'Audio Playback',
  'voice.highQualityVoice': 'Premium natural voice enabled',
  'voice.browserVoiceFallback': 'Instant browser voice playback',
  'voice.shortAudio': 'Short-form audio',
  'voice.playAudio': 'Play audio',
  'voice.pauseAudio': 'Pause audio',
  'voice.premiumHint': 'Upgrade to premium for downloadable MP3 and higher-quality voices.',
  'voice.premiumEnabled': 'Premium voice output is active',
  'voice.basicPlayback': 'Basic voice playback is available for free',
  'voice.premiumDownloadOnly': 'MP3 downloads are available for premium users only.',
  'voice.downloadReady': 'MP3 download ready!',
  'voice.rateLimited': 'Voice service is busy right now. Please try again in a moment.',

  // Translation History
  'history.title': 'Translation History',
  'history.noTranslations': 'No translations yet',
  'history.recentTranslations': 'Your recent translations',
  'history.emptyMessage': 'Your translation history will appear here once you start translating.',

  // Trial Progress
  'trial.progress': 'Trial Progress',
  'trial.requestsLeft': 'requests left',
  'trial.limitReached': 'Trial limit reached. Please subscribe to continue.',

  // Footer
  'footer.copyright': '© 2026 PH Lim IgniteAITool. All rights reserved',
  'footer.contactSupport': 'Contact Support',
  'footer.admin': 'Admin',
  'footer.addToChrome': 'Download Extension',
  'footer.extensionTooltip': 'Install our Chrome Extension for faster translation',
  'footer.free': 'Free',
  'footer.startTranslating': 'Start Translating for Free',
  'footer.chromeExtTitle': 'Chrome Extension',
  'footer.chromeExtDesc': 'Use our Chrome Extension for faster translation directly in your browser.',
  'footer.chromeExtManual': 'Not sure how to install? View Installation Guide',
  'footer.installationGuide': 'Installation Guide',
  'footer.privacyPolicy': 'Privacy Policy',
  'footer.termsOfService': 'Terms of Service',

  // Trust section
  'trust.securePrivate': '🔒 Secure & Private',
  'trust.dataProtected': 'Your data is protected',
  'trust.noDataStored': 'No data stored after translation',

  // Secondary CTA
  'cta.readyToTranslate': 'Ready to break language barriers?',
  'cta.upgradeUnlimited': 'Upgrade to Unlimited',

  // Auth page
  'auth.translatorAiApp': 'Translator AI App',
  'auth.breakDownBarriers': 'Break Down Language Barriers',
  'auth.authSubtitle': 'Break down language barriers in seconds. Translate text, images, and voice across 100+ languages instantly with our professional AI translator.',
  'auth.multipleLanguages': 'Multiple Languages',
  'auth.multipleLanguagesDesc': 'Support for 100+ languages worldwide including English, Chinese, Spanish, Arabic, and many more',
  'auth.imageTranslation': 'Image & Voice Translation',
  'auth.imageTranslationDesc': 'Extract and translate text from images or simply speak to get instant translations using advanced AI OCR and voice recognition technology',
  'auth.securePrivate': 'Secure & Private',
  'auth.securePrivateDesc': 'Your translations are processed securely with enterprise-grade encryption',
  'auth.lightningFast': 'Lightning Fast',
  'auth.lightningFastDesc': 'Get accurate translations in seconds with our optimized AI models',
  'auth.signUpFreeTrial': 'Sign up for Free Trial',
  'auth.noCreditCard': 'No credit card required · Start translating instantly',
  'auth.welcomeToTranslator': 'Welcome to Translator',
  'auth.getStartedFreeTrial': 'Get started with your free trial',
  'auth.signIn': 'Sign In',
  'auth.signUp': 'Sign Up',
  'auth.email': 'Email',
  'auth.username': 'Username',
  'auth.password': 'Password',
  'auth.passwordHint': 'Must be 8+ characters with uppercase, lowercase, and numbers',
  'auth.forgotPassword': 'Forgot password?',
  'auth.signingIn': 'Signing in...',
  'auth.creatingAccount': 'Creating account...',
  'auth.chooseUsername': 'Choose a username',
  'auth.resetPassword': 'Reset Password',
  'auth.resetDescription': 'Enter your email to receive a reset link',
  'auth.sending': 'Sending...',
  'auth.sendResetLink': 'Send Reset Link',
  'auth.backToSignIn': 'Back to Sign In',
  'auth.accountCreated': 'Account created successfully!',
  'auth.signedIn': 'Signed in successfully!',
  'auth.resetSent': 'If an account with that email exists, a reset link has been sent.',
  'auth.alreadyRegistered': 'This email is already registered. Please sign in or use a different email.',
  'auth.invalidCredentials': 'Invalid email or password. Please try again.',
  'auth.deviceTrialUsed': 'This device has already used a trial. Please subscribe to continue.',

  // Account page
  'account.info': 'Account Information',
  'account.manageAccount': 'Manage your account and subscription',
  'account.username': 'Username',
  'account.accountStatus': 'Account Status',
  'account.subscribed': 'Subscribed',
  'account.trial': 'Trial',
  'account.membershipStatus': 'Membership Status',
  'account.membershipDesc': 'Your membership application status',
  'account.membershipActive': 'Membership active',
  'account.pendingApproval': 'Pending approval',
  'account.accountBlocked': 'Account blocked. Contact admin.',
  'account.noMembership': 'No membership record found.',
  'account.applyMembership': 'Apply for Membership',
  'account.trialStatus': 'Trial Status',
  'account.currentTrialUsage': 'Your current trial usage',
  'account.remainingRequests': 'Remaining Requests',
  'account.trialDaysLeft': 'Trial Days Left',
  'account.days': 'days',
  'account.trialEndedMsg': 'Your trial has ended. Subscribe to continue using the translator.',
  'account.subscribeNow': 'Subscribe Now - $4.97/month',
  'account.subscription': 'Subscription',
  'account.subscriptionDetails': 'Your subscription details',
  'account.nextBilling': 'Next billing date:',
  'account.accountActions': 'Account Actions',
  'account.logOut': 'Log Out',

  // Contact page
  'contact.title': 'Contact Support',
  'contact.subtitle': 'Have a question or need help? Send us a message and we\'ll get back to you as soon as possible.',
  'contact.fullName': 'Full Name *',
  'contact.email': 'Email *',
  'contact.phone': 'Phone (optional)',
  'contact.company': 'Company (optional)',
  'contact.topic': 'Topic *',
  'contact.selectTopic': 'Select a topic',
  'contact.message': 'Message *',
  'contact.messagePlaceholder': 'Tell us how we can help you...',
  'contact.characters': 'characters',
  'contact.consent': 'I agree that my data will be processed to handle my inquiry. *',
  'contact.sending': 'Sending...',
  'contact.sendMessage': 'Send Message',
  'contact.openWhatsApp': 'Open WhatsApp',
  'contact.missingInfo': 'Missing Information',
  'contact.fillRequired': 'Please fill in all required fields before submitting.',
  'contact.invalidEmail': 'Invalid Email',
  'contact.validEmail': 'Please enter a valid email address.',
  'contact.consentRequired': 'Consent Required',
  'contact.consentMsg': 'Please agree to the data processing consent before submitting.',
  'contact.success': 'Submission successful',
  'contact.openingWhatsApp': 'Opening WhatsApp…',
  'contact.error': 'Error',
  'contact.errorMsg': 'Failed to send message. Please try again.',
  'contact.generalInquiry': 'General Inquiry',
  'contact.technicalSupport': 'Technical Support',
  'contact.billingSubscription': 'Billing & Subscription',
  'contact.featureRequest': 'Feature Request',
  'contact.bugReport': 'Bug Report',
  'contact.other': 'Other',

  // Access Gate Modal
  'gate.membersOnly': 'Members Only Feature',
  'gate.signUpOrLogin': 'Please sign up or log in to continue.',
  'gate.goToLogin': 'Go to Login',
  'gate.underReview': 'Account Under Review',
  'gate.pendingApproval': 'Your registration is pending admin approval.',
  'gate.ok': 'OK',
  'gate.restricted': 'Account Restricted',
  'gate.cannotAccess': 'Your account cannot access this feature.',
  'gate.trialEnded': 'Trial Period Ended',
  'gate.trialEndedMessage': 'Your free trial has ended. Please subscribe to continue using the translation service.',
  'gate.subscribe': 'Subscribe Now',
  'gate.trialEndedMessageV2': 'Your free trial has ended. Unlock unlimited translations now.',
  'gate.upgradeNow': 'Upgrade Now',

  // Install App Modal
  'install.appInstalled': 'App Installed',
  'install.installApp': 'Install App',
  'install.installTheApp': 'Install the App',
  'install.nativeExperience': 'Get a faster, native-like experience on your device.',
  'install.whyInstall': 'Why install?',
  'install.fasterAccess': 'Faster access from your home screen',
  'install.fullScreen': 'Full-screen experience',
  'install.feelsLikeApp': 'Feels like a real mobile app',
  'install.iphoneTitle': '📱 Install on iPhone (Safari)',
  'install.iphoneStep1': 'Open this site in Safari',
  'install.iphoneStep2': 'Tap the Share button (square with arrow)',
  'install.iphoneStep3': 'Tap "Add to Home Screen"',
  'install.iphoneStep4': 'Tap "Add"',
  'install.androidTitle': '🤖 Install on Android (Chrome)',
  'install.androidStep1': 'Open this site in Chrome',
  'install.androidStep2': 'Tap the menu (three dots)',
  'install.androidStep3': 'Tap "Install App" or "Add to Home Screen"',
  'install.androidStep4': 'Confirm installation',
  'install.tryInstall': 'Try Install',
  'install.close': 'Close',

  // Member Register
  'member.signUp': 'Membership Sign Up',
  'member.fillDetails': 'Fill in your details to register for membership.',
  'member.email': 'Email *',
  'member.displayName': 'Display Name',
  'member.phone': 'Phone',
  'member.company': 'Company',
  'member.register': 'Register',
  'member.submitting': 'Submitting...',
  'member.errorRequired': 'Email is required.',
  'member.submissionFailed': 'Submission Failed',
  'member.success': 'Registration successful',
  'member.successDesc': 'We have received your information.',

  // Not Found
  'notFound.title': '404',
  'notFound.message': 'Oops! Page not found',
  'notFound.returnHome': 'Return to Home',

  // Subscribe
  'subscribe.backToAccount': 'Back to Account',
  'subscribe.chooseYourPlan': 'Choose Your Plan',
  'subscribe.unlockUnlimited': 'Unlock unlimited translations and premium features',
  'subscribe.trial': 'Trial',
  'subscribe.getStartedFree': 'Get started for free',
  'subscribe.free': '$0',
  'subscribe.sevenDays': '/7 days',
  'subscribe.tenRequests': '10 translation requests',
  'subscribe.textAndImage': 'Text & image translation',
  'subscribe.seventeenLangs': '100+ languages supported',
  'subscribe.sevenDayTrial': '7-day trial period',
  'subscribe.currentPlan': 'Current Plan',
  'subscribe.popular': 'Popular',
  'subscribe.premium': 'Premium',
  'subscribe.fullAccess': 'Full access to all features',
  'subscribe.price': '$4.97',
  'subscribe.perMonth': '/month',
  'subscribe.unlimitedTranslations': 'Unlimited translations',
  'subscribe.translationHistory': 'Translation history',
  'subscribe.prioritySupport': 'Priority support',
  'subscribe.noAds': 'No ads',
  'subscribe.subscribeNow': 'Subscribe Now',
  'subscribe.processing': 'Processing...',
  'subscribe.error': 'Failed to start subscription. Please try again.',

  // Membership errors
  'membership.pending': 'Your account is pending approval. Please wait for admin review.',
  'membership.blocked': 'Your account is restricted. Please contact support.',

  // Language selector
  'language.select': 'Language',
  'language.translating': 'Translating UI...',
  'language.search': 'Search languages...',
  'language.recent': 'Recently Used',
  'language.popular': 'Popular',
  'language.all': 'All Languages',
  'language.noResults': 'No languages found',

  // Installation Guide
  'guide.backToHome': 'Back to Home',
  'guide.title': 'How to Install Chrome Extension',
  'guide.subtitle': 'Follow these simple steps to install the AI Translator Chrome Extension on your browser.',
  'guide.downloadFirst': 'Download the extension first',
  'guide.downloadFirstDesc': 'Make sure you have downloaded and extracted the extension files before proceeding.',
  'guide.noteTitle': 'Manual Installation',
  'guide.noteDesc': 'This is a manual installation using Developer Mode since the extension is not yet available on the Chrome Web Store. It works on all Chromium browsers including Chrome, Edge, Brave, and Opera.',
  'guide.needHelp': 'Need help with the installation?',

  // Loading
  'loading': 'Loading...',
};
